module.exports = __webpack_public_path__ + "static/media/microscopy-yliv-01 4.4440acf7.png";